<template>
    <div class="sidebar-filters">
        <div class="sidebar-header">
            <div class="header-left">
                <i class="dx-icon-filter icon-main"></i>
                <span class="sidebar-title">Filtre</span>
            </div>
            <DxButton icon="close" styling-mode="text" class="close-sidebar-btn-small"
                @click="$emit('close-sidebar')" />
        </div>

        <div class="filters-container">
            <DxAccordion :items="accordionItems" :multiple="false" :collapsible="true"
                v-model:selected-item-keys="selectedAccordionKeys" key-expr="id" class="filters-accordion">
                <template #title="{ data }">
                    <div class="accordion-title-wrapper">
                        <i :class="data.icon"></i>
                        <span class="accordion-title-text">{{ data.title }}</span>
                    </div>
                </template>
                <template #item="{ data }">
                    <div class="accordion-item-content">
                        <!-- Date Section -->
                        <div v-if="data.id === 'date'" class="filter-group-inner">
                            <div class="filter-input">
                                <DxDateBox :show-clear-button="true" type="date" display-format="dd-MM-yyyy"
                                    label="De la" label-mode="floating" v-model:value="dataDocStart" />
                            </div>
                            <div class="filter-input">
                                <DxDateBox :show-clear-button="true" type="date" display-format="dd-MM-yyyy"
                                    label="Până la" label-mode="floating" v-model:value="dataDocEnd" />
                            </div>
                        </div>

                        <!-- Document Section -->
                        <div v-if="data.id === 'document'" class="filter-group-inner">
                            <div class="filter-input">
                                <label class="group-label">Serie/Număr</label>
                                <DxTextBox v-model:value="tbSerie" placeholder="Serie document..." label-mode="floating"
                                    label="Serie" />
                            </div>
                            <div class="filter-input">
                                <DxLookup :data-source="dsCategorieDocumente" display-expr="Nume" value-expr="Id"
                                    label-mode="floating" label="Categorie" :show-clear-button="true"
                                    :search-enabled="true" @value-changed="onValueChangedCategorie">
                                    <DxDropDownOptions :show-title="false" />
                                </DxLookup>
                            </div>
                            <div class="filter-input">
                                <DxLookup ref="tipDocumentLookup" :data-source="dsTipDocumente" display-expr="Nume"
                                    value-expr="Id" label-mode="floating" label="Tip Document" :show-clear-button="true"
                                    :search-enabled="true" :value="sTipDocumente" @value-changed="onValueChangedTipDocument">
                                    <DxDropDownOptions :show-title="false" />
                                </DxLookup>
                            </div>
                        </div>

                        <!-- Partners & Zones Section -->
                        <div v-if="data.id === 'partners'" class="filter-group-inner">
                            <div class="filter-input">
                                <DxLookup :data-source="dsGrupePartener" display-expr="Nume" value-expr="Id"
                                    label-mode="floating" label="Grup Parteneri" :show-clear-button="true"
                                    :search-enabled="true" :value="GrupaPartenerID" @value-changed="onValueChangedGrupePartener">
                                    <DxDropDownOptions :show-title="false" />
                                </DxLookup>
                            </div>
                            <div class="filter-input">
                                <DxLookup :data-source="dsZone" display-expr="Nume" value-expr="Id"
                                    label-mode="floating" label="Zona" :show-clear-button="true" :search-enabled="true"
                                    @value-changed="onValueChangedZone">
                                    <DxDropDownOptions :show-title="false" />
                                </DxLookup>
                            </div>
                            <div class="filter-input">
                                <DxDropDownBox ref="partenerLookup" :data-source="dsPartener" :show-clear-button="true"
                                    placeholder="Partener" label-mode="floating" label="Partener"
                                    :display-expr="partenerDisplayExpr" value-expr="ID"
                                    @value-changed="onPartenerValueChanged">
                                    <template #content="{ data }">
                                        <DxDataGrid :data-source="dsPartener" :columns="['CUI', 'Nume']"
                                            :hover-state-enabled="true" @selection-changed="onValueSelectedPartener"
                                            height="100%">
                                            <DxSelection mode="single" />
                                            <DxPaging :enabled="true" :page-size="5" />
                                            <DxFilterRow :visible="true" />
                                            <DxSearchPanel :visible="true" placeholder="Cauta ..." />
                                        </DxDataGrid>
                                    </template>
                                </DxDropDownBox>
                            </div>
                        </div>

                        <!-- References Section -->
                        <div v-if="data.id === 'references'" class="filter-group-inner">
                            <div class="filter-input">
                                <DxDropDownBox ref="proiectLookup" :data-source="dsProiect" :show-clear-button="true"
                                    placeholder="Proiect" label-mode="floating" label="Proiect"
                                    :display-expr="proiectDisplayExpr" value-expr="Id"
                                    @value-changed="onProiectValueChanged">
                                    <template #content="{ data }">
                                        <DxDataGrid :data-source="dsProiect" :columns="['Cod', 'Nume']"
                                            :hover-state-enabled="true" @selection-changed="onValueSelectedProiect"
                                            height="100%">
                                            <DxSelection mode="single" />
                                            <DxPaging :enabled="true" :page-size="5" />
                                            <DxFilterRow :visible="true" />
                                            <DxSearchPanel :visible="true" placeholder="Cauta ..." />
                                        </DxDataGrid>
                                    </template>
                                </DxDropDownBox>
                            </div>
                            <div class="filter-input">
                                <DxDropDownBox ref="comandaLookup" :data-source="dsComanda" :show-clear-button="true"
                                    placeholder="Comanda" label-mode="floating" label="Comandă"
                                    :display-expr="comandaDisplayExpr" value-expr="Id"
                                    @value-changed="onComandaValueChanged">
                                    <template #content="{ data }">
                                        <DxDataGrid :data-source="dsComanda" :columns="['Cod', 'Nume']"
                                            :hover-state-enabled="true" height="100%"
                                            @selection-changed="onValueSelectedComanda">
                                            <DxSelection mode="single" />
                                            <DxPaging :enabled="true" :page-size="5" />
                                            <DxFilterRow :visible="true" />
                                            <DxSearchPanel :visible="true" placeholder="Cauta ..." />
                                        </DxDataGrid>
                                    </template>
                                </DxDropDownBox>
                            </div>
                            <div class="filter-input">
                                <DxLookup ref="agentLookup" :data-source="dsAgent" display-expr="Nume" value-expr="Id"
                                    label-mode="floating" label="Agent" :show-clear-button="true" :search-enabled="true"
                                    :value="sAgent" @value-changed="onValueChangedAgent">
                                    <DxDropDownOptions :show-title="false" />
                                </DxLookup>
                            </div>
                        </div>

                        <!-- Products Section -->
                        <div v-if="data.id === 'products'" class="filter-group-inner">
                            <div class="filter-input">
                                <label class="group-label">Produs (Cod/Nume)</label>
                                <DxTextBox v-model:value="tbProdus" placeholder="Cauta produs..."
                                    label-mode="floating" />
                            </div>
                            <div class="filter-input">
                                <DxLookup :data-source="dsCategorieProdus" display-expr="Nume" value-expr="Id"
                                    label-mode="floating" label="Categorie Produs" :show-clear-button="true"
                                    :search-enabled="true" v-model:value="sCategorieProdus">
                                    <DxDropDownOptions :show-title="false" />
                                </DxLookup>
                            </div>
                        </div>
                    </div>
                </template>
            </DxAccordion>

            <div class="sidebar-footer">
                <DxButton text="Caută" type="default" icon="search" @click="Cautare" class="sidebar-search-btn" />
            </div>
        </div>
    </div>
</template>
<script lang="ts">

import DxDropDownBox from 'devextreme-vue/drop-down-box';
import { DxDropDownOptions, DxLookup } from 'devextreme-vue/lookup';
import DataSource from 'devextreme/data/data_source';
import AppSetting from '@/settings/appSettings'
import { DxCheckBox } from 'devextreme-vue/check-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxButton from 'devextreme-vue/button';
import { defineComponent } from 'vue'
import notify from 'devextreme/ui/notify';
import DxDateBox from 'devextreme-vue/date-box';
import {
    DxDataGrid, DxSelection, DxPaging, DxFilterRow, DxScrolling, DxSearchPanel,
} from 'devextreme-vue/data-grid';
import {
    DxResponsiveBox, DxItem, DxLocation, DxCol, DxRow,
} from 'devextreme-vue/responsive-box';
import DxAccordion from 'devextreme-vue/accordion';

export default {

    name: 'SearchFilters',
    components: {
        DxLookup,
        DxDropDownOptions,
        DxCheckBox,
        DxTextBox,
        DxDropDownBox,
        DxButton,
        DxDateBox,
        DxDataGrid,
        DxSelection,
        DxPaging,
        DxFilterRow,
        DxScrolling,
        DxSearchPanel,
        DxResponsiveBox,
        DxItem,
        DxLocation,
        DxCol,
        DxRow,
        DxAccordion,
    },

    data() {
        return {
            isAdvancedVisible: false,
            selectedAccordionKeys: ['document'],
            accordionItems: [
                { id: 'date', title: 'Dată & Perioadă', icon: 'dx-icon-event' },
                { id: 'document', title: 'Document', icon: 'dx-icon-doc' },
                { id: 'partners', title: 'Parteneri & Zone', icon: 'dx-icon-group' },
                { id: 'references', title: 'Referințe & Advanced', icon: 'dx-icon-preferences' },
                { id: 'products', title: 'Produse', icon: 'dx-icon-product' }
            ],

            dataDocStart: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            dataDocEnd: new Date(),

            sCategorie: null,
            dsCategorieDocumente: null,

            sTipDocumente: null,
            dsTipDocumente: null,

            sZone: null,
            dsZone: null,

            sPartener: null,
            dsPartener: null,

            sProiect: null,
            dsProiect: null,

            sComanda: null,
            dsComanda: null,

            sAgent: null,
            dsAgent: null,

            params: null,

            GrupaPartenerID: null,


            dsGrupePartener: null,


            sCategorieProdus: null,
            dsCategorieProdus: {
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'PRO_Categorii',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },

            },

            sProduse: null,
            dsProduse: {
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'PRO_Produse',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },

            },


            sCategorieContabila: null,
            dsCategorieContabila: {
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'CON_CategoriiContabile',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },

            },


            sCapitole: null,
            dsCapitole: {
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'DOC_Capitole',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
            },
            tbSerie: '',
            tbProdus: '',

            sCategorieNume: '',
            sTipDocumenteNume: '',
            sZoneNume: '',
            sPartenerNume: '',
            sProiectNume: '',
            sComandaNume: '',
            sAgentNume: '',
            sGrupaPartenerNume: '',
        }
    },
    mounted() {
        try {
            const stored = localStorage.getItem('doc_search_filters');
            if (stored) {
                const saved = JSON.parse(stored);
                if (saved.dataDocStart) this.dataDocStart = new Date(saved.dataDocStart);
                if (saved.dataDocEnd) this.dataDocEnd = new Date(saved.dataDocEnd);
                this.sCategorie = saved.sCategorie ?? null;
                this.sTipDocumente = saved.sTipDocumente ?? null;
                this.sZone = saved.sZone ?? null;
                this.sPartener = saved.sPartener ?? null;
                this.sProiect = saved.sProiect ?? null;
                this.sComanda = saved.sComanda ?? null;
                this.sAgent = saved.sAgent ?? null;
                this.GrupaPartenerID = saved.GrupaPartenerID ?? null;
                this.tbSerie = saved.tbSerie ?? '';
                this.sCategorieNume = saved.sCategorieNume ?? '';
                this.sTipDocumenteNume = saved.sTipDocumenteNume ?? '';
                this.sZoneNume = saved.sZoneNume ?? '';
                this.sPartenerNume = saved.sPartenerNume ?? '';
                this.sProiectNume = saved.sProiectNume ?? '';
                this.sComandaNume = saved.sComandaNume ?? '';
                this.sAgentNume = saved.sAgentNume ?? '';
                this.sGrupaPartenerNume = saved.sGrupaPartenerNume ?? '';
                if (this.sCategorie && this.dsTipDocumente) {
                    this.dsTipDocumente.filter(['CategorieId', '=', this.sCategorie]);
                }
                if (this.sProiect && this.dsComanda) {
                    this.dsComanda.filter(['ProiectID', '=', this.sProiect]);
                }
            }
        } catch (e) {
            console.error('Eroare restaurare filtre:', e);
        }
        this.Cautare(null);
    },
    created() {
        this.dsCategorieDocumente = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + 'DOC_Categorii',
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            },
        });
        this.dsPartener = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + 'PAR_Parteneri',
                key: 'ID',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            },
            select: [
                'ID',
                'Nume',
                'CUI'
            ],
        });
        this.dsTipDocumente = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + `DOC_Tipuri`,
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            },
            select: [
                'Id',
                'Nume',
            ]

        });
        this.dsGrupePartener = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + 'PAR_Grupuri',
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            },

        });
        this.dsZone = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + 'ERP_Zone',
                key: 'Id',
                keyType: "Guid",
                version: 4,

                beforeSend: (e: any) => {

                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                    };
                }
            },

        });
        this.dsProiect = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + 'DOC_Proiecte',
                key: 'Id',
                keyType: "Guid",
                version: 4,

                beforeSend: (e: any) => {

                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            },
            select: [
                'Id',
                'Nume',
                'Cod'
            ]
        })
        this.dsComanda = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + 'PRO_Comenzi',
                key: 'Id',
                keyType: "Guid",
                version: 4,

                beforeSend: (e: any) => {

                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                }
            },
            select: [
                'Id',
                'Nume',
                'Cod'
            ]
        })
        this.dsAgent = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_DocumenteOdata + 'COM_Agenti',
                key: 'Id',
                keyType: "Guid",
                version: 4,

                beforeSend: (e: any) => {

                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                    };
                }
            },

        })
    },

    methods: {
        partenerDisplayExpr(item) {
            return item ? `${item.CUI} - ${item.Nume}` : '';
        },
        proiectDisplayExpr(item) {
            return item ? `${item.Cod} - ${item.Nume}` : '';
        },
        comandaDisplayExpr(item) {
            return item ? `${item.Cod} - ${item.Nume}` : '';
        },

        onValueChangedCategorie(e: any) {
            this.sCategorie = e.value;
            this.sCategorieNume = e.component.option('selectedItem')?.Nume || '';
            this.sTipDocumente = null;
            this.sTipDocumenteNume = '';
            this.$refs["tipDocumentLookup"].instance.reset();

            let _filter;

            if (e.value != null) {
                _filter = ["CategorieId", "=", e.value];
            } else {
                _filter = null;
            }

            this.dsTipDocumente.filter(_filter);
            this.dsTipDocumente.load();

        }, //checkedv

        onValueChangedTipDocument(e: any) {
            this.sTipDocumente = e.value;
            this.sTipDocumenteNume = e.component.option('selectedItem')?.Nume || '';
        },//checkedv

        onValueChangedGrupePartener(e: any) {
            this.GrupaPartenerID = e.value;
            this.sGrupaPartenerNume = e.component.option('selectedItem')?.Nume || '';

            let _filter;

            this.sPartener = null;
            this.sPartenerNume = '';
            this.$refs["partenerLookup"].instance.reset();

            if (e.value != null) {
                if (this.sZone != null) {
                    _filter = [["GrupID", "=", e.value], "and", ["ZonaID", "=", this.sZone]];
                } else {
                    _filter = ["GrupID", "=", e.value];
                }

            } else {
                if (this.sZone != null) {
                    _filter = ["ZonaID", "=", this.sZone];
                } else {
                    _filter = null;
                }

            }

            this.dsPartener.filter(_filter);
            this.dsPartener.load();
        }, //checkedv

        onValueChangedZone(e: any) {
            this.sZone = e.value;
            this.sZoneNume = e.component.option('selectedItem')?.Nume || '';
            let _filter;
            this.sPartener = null;
            this.sPartenerNume = '';
            this.$refs["partenerLookup"].instance.reset();

            if (e.value != null) {
                if (this.GrupaPartenerID != null) {
                    _filter = [["ZonaID", "=", e.value], "and", ["GrupID", "=", this.GrupaPartenerID]];
                } else {
                    _filter = ["ZonaID", "=", e.value];
                }

            } else {
                if (this.GrupaPartenerID != null) {
                    _filter = ["GrupID", "=", this.GrupaPartenerID];
                } else {
                    _filter = null;
                }

            }
            this.dsPartener.filter(_filter);
            this.dsPartener.load();


        },//checkedv
        onPartenerValueChanged(e: any) {
            if (e.value === null) {
                this.sPartener = null;
                this.sPartenerNume = '';
            } else {
                this.sPartener = e.value;
            }
        },
        onValueSelectedPartener(e: any) {
            if (e.selectedRowKeys.length > 0) {
                this.sPartener = e.selectedRowsData[0].ID;
                this.sPartenerNume = e.selectedRowsData[0].Nume || '';
                this.$refs["partenerLookup"].instance.option('value', this.sPartener);
            } else {
                this.sPartener = null;
                this.sPartenerNume = '';
                this.$refs["partenerLookup"].instance.option('value', null);
            }
            this.$refs["partenerLookup"].instance.close();
        },//checkedv
        onProiectValueChanged(e: any) {
            if (e.value === null) {
                this.sProiect = null;
                this.sProiectNume = '';
                this.sComanda = null;
                this.sComandaNume = '';
            } else {
                this.sProiect = e.value;
            }
        },
        onValueSelectedProiect(e: any) {
            if (e.selectedRowKeys.length > 0) {
                this.sProiect = e.selectedRowsData[0].Id;
                this.sProiectNume = e.selectedRowsData[0].Cod
                    ? `${e.selectedRowsData[0].Cod} - ${e.selectedRowsData[0].Nume || ''}`
                    : e.selectedRowsData[0].Nume || '';
                this.$refs["proiectLookup"].instance.option('value', this.sProiect);
            } else {
                this.sProiect = null;
                this.sProiectNume = '';
                this.$refs["proiectLookup"].instance.option('value', null);
            }
            this.$refs["proiectLookup"].instance.close();

            let _filter = null;
            this.sComanda = null;
            this.sComandaNume = '';
            this.$refs["comandaLookup"].instance.reset();

            if (this.sProiect != null) {

                _filter = ["ProiectID", "=", this.sProiect];
            }

            this.dsComanda.filter(_filter);
            this.dsComanda.load();

        },//checkedv
        onComandaValueChanged(e: any) {
            if (e.value === null) {
                this.sComanda = null;
                this.sComandaNume = '';
            } else {
                this.sComanda = e.value;
            }
        },
        onValueSelectedComanda(e: any) {
            if (e.selectedRowKeys.length > 0) {
                this.sComanda = e.selectedRowsData[0].Id;
                this.sComandaNume = e.selectedRowsData[0].Cod
                    ? `${e.selectedRowsData[0].Cod} - ${e.selectedRowsData[0].Nume || ''}`
                    : e.selectedRowsData[0].Nume || '';
                this.$refs["comandaLookup"].instance.option('value', this.sComanda);
            } else {
                this.sComanda = null;
                this.sComandaNume = '';
                this.$refs["comandaLookup"].instance.option('value', null);
            }
            this.$refs["comandaLookup"].instance.close();
        },//checkedv

        onValueChangedAgent(e: any) {
            this.sAgent = e.value;
            this.sAgentNume = e.component.option('selectedItem')?.Nume || '';
        },//checkedv


        // onValueChangedDataScadentaStart(e: any) {
        //     this.dataScadentaStart = e.value;
        // },

        // onValueChangedDataScadentaEnd(e: any) {
        //     this.dataScadentaEnd = e.value;
        // },

        onValueChangedCategorieProdus(e) {
            this.sCategorieProdus = e.value;
        },
        onValueChangedProduse(e) {
            this.sProduse = e.value;
            console.log("Test: " + this.sProduse);
        },
        onValueChangedCategorieContabila(e) {
            this.sCategorieContabila = e.value;
        },

        onValueChangedComanda(e) {
            this.sComanda = e.component.option("text") === "" ? null : e.component.option("text");
        },
        onValueChangedCapitole(e) {
            this.sCapitole = e.value;
        },
        Cautare(e) {
            this.params = {
                filters: [],
            };

            // Date Filters (Relocated here)
            if (this.dataDocStart != null) {
                const start = new Date(this.dataDocStart);
                start.setHours(0, 0, 0, 0);
                this.params.filters.push(["Data", ">=", start]);
                this.params.filters.push("and");
            }

            if (this.dataDocEnd != null) {
                const end = new Date(this.dataDocEnd);
                end.setHours(23, 59, 59, 999);
                this.params.filters.push(["Data", "<=", end]);
                this.params.filters.push("and");
            }

            // Document Number / Serie
            if (this.tbSerie && this.tbSerie.trim() !== '') {
                this.params.filters.push(["Numar", "contains", this.tbSerie]);
                this.params.filters.push("and");
            }

            if (this.sTipDocumente != null) {
                this.params.filters.push(["TipId", "=", this.sTipDocumente]);
                this.params.filters.push("and");
            }

            if (this.sCategorie != null) {
                this.params.filters.push(["CategorieId", "=", this.sCategorie]);
                this.params.filters.push("and");
            }

            if (this.GrupaPartenerID != null) {
                this.params.filters.push(["GrupPartenerID", "=", this.GrupaPartenerID]);
                this.params.filters.push("and");
            }

            if (this.sZone != null) {
                this.params.filters.push(["ZonaID", "=", this.sZone]);
                this.params.filters.push("and");
            }

            if (this.sPartener != null) {
                this.params.filters.push(["PartenerID", "=", this.sPartener]);
                this.params.filters.push("and");
            }

            if (this.sProiect != null) {
                this.params.filters.push(["ProiectID", "=", this.sProiect]);
                this.params.filters.push("and");
            }

            if (this.sComanda != null) {
                this.params.filters.push(["ComandaID", "=", this.sComanda]);
                this.params.filters.push("and");
            }


            // if (this.dataScadentaStart != null) {
            //     this.dataScadentaStart.setHours(0, 0, 0, 0);
            //     this.params.filters.push(["Scadenta", ">=", this.dataScadentaStart]);
            //     this.params.filters.push("and");
            // }

            // if (this.dataScadentaEnd != null) {
            //     this.dataScadentaEnd.setHours(23, 59, 59, 999);
            //     this.params.filters.push(["Scadenta", "<=", this.dataScadentaEnd]);
            //     this.params.filters.push("and");
            // }

            if (this.sAgent != null) {
                this.params.filters.push(["AgentID", "=", this.sAgent]);
                this.params.filters.push("and");
            }

            // Product Filters
            //if (this.tbProdus && this.tbProdus.trim() !== '') {
                // In Line Search mode, we target Produs.Nume or Produs.Cod
                // In Document search mode, it might not be relevant unless the service supports it
            //     this.params.filters.push([
            //         ["Produs/Nume", "contains", this.tbProdus],
            //         "or",
            //         ["Produs/Cod", "contains", this.tbProdus]
            //     ]);
            //     this.params.filters.push("and");
            // }

            // if (this.sCategorieProdus != null) {
            //     this.params.filters.push(["Produs/CategorieId", "=", this.sCategorieProdus]);
            //     this.params.filters.push("and");
            // }

            if (this.params.filters.length > 0)
                this.params.filters.pop();
            else
                this.params.filters = null;


            try {
                localStorage.setItem('doc_search_filters', JSON.stringify({
                    dataDocStart: this.dataDocStart ? new Date(this.dataDocStart).toISOString() : null,
                    dataDocEnd: this.dataDocEnd ? new Date(this.dataDocEnd).toISOString() : null,
                    sCategorie: this.sCategorie,
                    sTipDocumente: this.sTipDocumente,
                    sZone: this.sZone,
                    sPartener: this.sPartener,
                    sProiect: this.sProiect,
                    sComanda: this.sComanda,
                    sAgent: this.sAgent,
                    GrupaPartenerID: this.GrupaPartenerID,
                    tbSerie: this.tbSerie,
                    sCategorieNume: this.sCategorieNume,
                    sTipDocumenteNume: this.sTipDocumenteNume,
                    sZoneNume: this.sZoneNume,
                    sPartenerNume: this.sPartenerNume,
                    sProiectNume: this.sProiectNume,
                    sComandaNume: this.sComandaNume,
                    sAgentNume: this.sAgentNume,
                    sGrupaPartenerNume: this.sGrupaPartenerNume,
                }));
            } catch (_) { /* ignore storage errors */ }

            const fmt = (d: any) => d
                ? new Date(d).toLocaleDateString('ro-RO', { day: '2-digit', month: '2-digit', year: 'numeric' })
                : '';
            const defaultStart = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
            const defaultEnd = new Date();
            const startDiffers = this.dataDocStart &&
                new Date(this.dataDocStart).toDateString() !== defaultStart.toDateString();
            const endDiffers = this.dataDocEnd &&
                new Date(this.dataDocEnd).toDateString() !== defaultEnd.toDateString();

            const activeFilters: any[] = [];
            if (startDiffers || endDiffers)
                activeFilters.push({ key: 'dates', label: `${fmt(this.dataDocStart)} – ${fmt(this.dataDocEnd)}` });
            if (this.tbSerie)
                activeFilters.push({ key: 'tbSerie', label: `Serie: ${this.tbSerie}` });
            if (this.sCategorie)
                activeFilters.push({ key: 'sCategorie', label: `Categ.: ${this.sCategorieNume}` });
            if (this.sTipDocumente)
                activeFilters.push({ key: 'sTipDocumente', label: `Tip: ${this.sTipDocumenteNume}` });
            if (this.GrupaPartenerID)
                activeFilters.push({ key: 'GrupaPartenerID', label: `Grup: ${this.sGrupaPartenerNume}` });
            if (this.sZone)
                activeFilters.push({ key: 'sZone', label: `Zonă: ${this.sZoneNume}` });
            if (this.sPartener)
                activeFilters.push({ key: 'sPartener', label: `Partener: ${this.sPartenerNume}` });
            if (this.sProiect)
                activeFilters.push({ key: 'sProiect', label: `Proiect: ${this.sProiectNume}` });
            if (this.sComanda)
                activeFilters.push({ key: 'sComanda', label: `Comandă: ${this.sComandaNume}` });
            if (this.sAgent)
                activeFilters.push({ key: 'sAgent', label: `Agent: ${this.sAgentNume}` });

            this.$emit('clicked', { filters: this.params, activeFilters })
        },
        clearFilter(key: string) {
            if (key === 'all') {
                this.dataDocStart = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                this.dataDocEnd = new Date();
                this.tbSerie = '';
                this.sCategorie = null; this.sCategorieNume = '';
                this.sTipDocumente = null; this.sTipDocumenteNume = '';
                this.GrupaPartenerID = null; this.sGrupaPartenerNume = '';
                this.sZone = null; this.sZoneNume = '';
                this.sPartener = null; this.sPartenerNume = '';
                this.sProiect = null; this.sProiectNume = '';
                this.sComanda = null; this.sComandaNume = '';
                this.sAgent = null; this.sAgentNume = '';
                try { (this.$refs["tipDocumentLookup"] as any)?.instance?.reset(); } catch (_) {}
                try { (this.$refs["partenerLookup"] as any)?.instance?.reset(); } catch (_) {}
                try { (this.$refs["proiectLookup"] as any)?.instance?.reset(); } catch (_) {}
                try { (this.$refs["comandaLookup"] as any)?.instance?.reset(); } catch (_) {}
                try { (this.$refs["agentLookup"] as any)?.instance?.reset(); } catch (_) {}
                this.Cautare(null);
                return;
            }
            switch (key) {
                case 'dates':
                    this.dataDocStart = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                    this.dataDocEnd = new Date();
                    break;
                case 'tbSerie':
                    this.tbSerie = '';
                    break;
                case 'sCategorie':
                    this.sCategorie = null; this.sCategorieNume = '';
                    this.sTipDocumente = null; this.sTipDocumenteNume = '';
                    try { (this.$refs["tipDocumentLookup"] as any)?.instance?.reset(); } catch (_) {}
                    break;
                case 'sTipDocumente':
                    this.sTipDocumente = null; this.sTipDocumenteNume = '';
                    break;
                case 'GrupaPartenerID':
                    this.GrupaPartenerID = null; this.sGrupaPartenerNume = '';
                    break;
                case 'sZone':
                    this.sZone = null; this.sZoneNume = '';
                    break;
                case 'sPartener':
                    this.sPartener = null; this.sPartenerNume = '';
                    try { (this.$refs["partenerLookup"] as any)?.instance?.reset(); } catch (_) {}
                    break;
                case 'sProiect':
                    this.sProiect = null; this.sProiectNume = '';
                    this.sComanda = null; this.sComandaNume = '';
                    try { (this.$refs["proiectLookup"] as any)?.instance?.reset(); } catch (_) {}
                    try { (this.$refs["comandaLookup"] as any)?.instance?.reset(); } catch (_) {}
                    break;
                case 'sComanda':
                    this.sComanda = null; this.sComandaNume = '';
                    try { (this.$refs["comandaLookup"] as any)?.instance?.reset(); } catch (_) {}
                    break;
                case 'sAgent':
                    this.sAgent = null; this.sAgentNume = '';
                    try { (this.$refs["agentLookup"] as any)?.instance?.reset(); } catch (_) {}
                    break;
            }
            this.Cautare(null);
        },
        openSection(sectionId) {
            this.selectedAccordionKeys = [sectionId];
        }

    }
}
</script>
<style scoped>
.sidebar-filters {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.sidebar-header {
    padding: 18px 20px;
    border-bottom: 1px solid #f1f5f9;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
}

.filters-container {
    flex-grow: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 10px 0;
}

.filters-accordion {
    padding: 0 10px;
}

.accordion-title-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 5px;
}

.accordion-title-wrapper i {
    color: #64748b;
    font-size: 16px;
}

.accordion-selected .accordion-title-wrapper i {
    color: #ff2c21;
}

.accordion-title-text {
    font-weight: 600;
    color: #1e293b;
    font-size: 14px;
}

.accordion-item-content {
    padding: 15px 10px 20px 10px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    border-top: 1px solid #f8fafc;
}

.filter-group-inner {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.close-sidebar-btn-small {
    color: #64748b !important;
    width: 32px !important;
    height: 32px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 8px !important;
    margin-right: -8px;
}

.close-sidebar-btn-small:hover {
    background-color: #fee2e2 !important;
    color: #ef4444 !important;
}

.icon-main {
    font-size: 18px;
    color: #ff2c21;
    background: rgba(255, 44, 33, 0.1);
    padding: 6px;
    border-radius: 8px;
}

.sidebar-title {
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
}

.filter-input {
    display: flex;
    flex-direction: column;
}

.group-label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 700;
    color: #94a3b8;
    margin-bottom: 4px;
}

.toggle-advanced-sidebar-btn {
    justify-content: flex-start;
    padding: 0;
    color: #64748b !important;
    font-size: 13px;
}

.sidebar-footer {
    padding: 20px;
    border-top: 1px solid #f1f5f9;
    background: #fff;
    flex-shrink: 0;
}

.sidebar-search-btn {
    width: 100% !important;
    height: 44px !important;
    background-color: #ff2c21 !important;
    color: white !important;
    border-radius: 10px !important;
    font-weight: 600 !important;
    box-shadow: 0 4px 12px rgba(255, 44, 33, 0.2) !important;
    transition: all 0.2s ease !important;
}

.sidebar-search-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(255, 44, 33, 0.3) !important;
}

/* Transition for expanding advanced filters */
.expand-enter-active,
.expand-leave-active {
    transition: all 0.3s ease-out;
    max-height: 400px;
    opacity: 1;
    overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
    max-height: 0;
    opacity: 0;
}

/* DevExtreme UI Tweak for Sidebar */
:deep(.dx-texteditor) {
    border-radius: 8px;
    background-color: #fcfcfc;
}

:deep(.dx-lookup-field-wrapper) {
    padding: 0 8px;
}
</style>
